import { useEffect,useState,useContext } from 'react';
import SmallPromoBox from "./smallPromo";
import AppContext from '../../../AppContext';
import { useAuth } from 'react-oidc-context';
import {uscall,getresourceurl} from '../../../us';
import nl2br from 'react-nl2br';


function PromoX1Box({areacode}) {
    const auth = useAuth();
    const [oldareacode,setOldAreaCode]=useState(null);
    const [box,setBox]=useState(null);
    const [bannerimageurl,setBannerimageurl]=useState(null);
    const [titleimageurl,setTitleimageurl]=useState(null);
    const appcontext = useContext(AppContext);
    useEffect(() => {
	if(areacode!=oldareacode){
		setOldAreaCode(areacode);
		setBox(null);
	}
    },[areacode]);
    useEffect(() => {
	const cb=async function(){
		const r=await uscall(appcontext,auth,'ecommerce','boxpromoarea','getbox',null,{areacode:oldareacode});
		if(typeof(r['error'])!='undefined');
		else if(typeof(r['result'])!='undefined' && r.result)setBox(r.result);
	}
	if(box);else if(oldareacode)
		cb();
    },[box,oldareacode,auth,appcontext,appcontext.manifest.relations]);
    useEffect(() => {
	const cb=async function(){
		setBannerimageurl(await getresourceurl(appcontext,auth,box.banner_image));
	}
	if(box && box.banner_image && (!bannerimageurl))
		cb();
    },[box,bannerimageurl,auth,appcontext]);
    useEffect(() => {
	const cb=async function(){
		setTitleimageurl(await getresourceurl(appcontext,auth,box.title_image));
	}
	if(box && box.titleisimage && box.title_image && (!titleimageurl))
		cb();
    },[box,bannerimageurl,auth,appcontext]);

    return (
        <>
                <div className={`dash-box h-460 ${box?'':'placeholder-glow'}`}>
					{box && box.titleisimage && titleimageurl?(
	        		            <img src={titleimageurl} alt={box.title} style={{minHeight:'auto',margin:'0 auto'}} />
					):(
		                    <h1 className={`text-center mb-0 p-0 ${box?'':'placeholder'}`} style={{ width: '100%' }}>{box?box.title:''}</h1>)}
        		            <h5 className={`text-center mx-auto mb-0 ${box?'':'placeholder'}`}>{box?nl2br(box.subtitle):''}</h5>
				    {box && box.isbanner?(<>
	        		            <img src={bannerimageurl?bannerimageurl:`${process.env.PUBLIC_URL}/placeholder-foto.png`} alt={box.title} />
	        		            <a href={box.banner_url} className="gradient-button">{box.banner_cta}</a>
						</>):(box?(<>
                    				<div className="row small-promo-container w-100 g-0">
                    					<SmallPromoBox url={box.box1_url} cta={box.box1_cta} color={box.box1_color} />
                        				<SmallPromoBox url={box.box2_url} cta={box.box2_cta} color={box.box2_color} />
                        				<SmallPromoBox url={box.box3_url} cta={box.box3_cta} color={box.box3_color} />
                        				<SmallPromoBox url={box.box4_url} cta={box.box4_cta} color={box.box4_color} />
                        				<SmallPromoBox url={box.box5_url} cta={box.box5_cta} color={box.box5_color} />
                        				<SmallPromoBox url={box.box6_url} cta={box.box6_cta} color={box.box6_color} />

                        				<SmallPromoBox url={box.box7_url} cta={box.box7_cta} color={box.box7_color} />
                        				<SmallPromoBox url={box.box8_url} cta={box.box8_cta} color={box.box8_color} />

                        				<SmallPromoBox url={box.box9_url} cta={box.box9_cta} color={box.box9_color} />
                        				<SmallPromoBox url={box.box10_url} cta={box.box10_cta} color={box.box10_color} />
                        				<SmallPromoBox url={box.box11_url} cta={box.box11_cta} color={box.box11_color} />
                        				<SmallPromoBox url={box.box12_url} cta={box.box12_cta} color={box.box12_color} />
                        				<SmallPromoBox url={box.box13_url} cta={box.box13_cta} color={box.box13_color} />
                        				<SmallPromoBox url={box.box14_url} cta={box.box14_cta} color={box.box14_color} />
                        				<SmallPromoBox url={box.box15_url} cta={box.box15_cta} color={box.box15_color} />
                        				<SmallPromoBox url={box.box16_url} cta={box.box16_cta} color={box.box16_color} />
                        				<SmallPromoBox url={box.box17_url} cta={box.box17_cta} color={box.box17_color} />
                        				<SmallPromoBox url={box.box18_url} cta={box.box18_cta} color={box.box18_color} />
                        				<SmallPromoBox url={box.box19_url} cta={box.box19_cta} color={box.box19_color} />
                        				<SmallPromoBox url={box.box20_url} cta={box.box20_cta} color={box.box20_color} />
                    				</div>

						</>):(<></>))}
                </div>
        </>
    )
}

export default PromoX1Box;
